<template>
  <access-alarm v-if="valueName == 'access_alarm'" />
  <access-alarms v-else-if="valueName == 'access_alarms'" />
  <access-time v-else-if="valueName == 'access_time'" />
  <ad-units v-else-if="valueName == 'ad_units'" />
  <add-alarm v-else-if="valueName == 'add_alarm'" />
  <add-to-home-screen v-else-if="valueName == 'add_to_home_screen'" />
  <airplanemode-active v-else-if="valueName == 'airplanemode_active'" />
  <airplanemode-inactive v-else-if="valueName == 'airplanemode_inactive'" />
  <battery-alert v-else-if="valueName == 'battery_alert'" />
  <battery-charging-full v-else-if="valueName == 'battery_charging_full'" />
  <battery-full v-else-if="valueName == 'battery_full'" />
  <battery-std v-else-if="valueName == 'battery_std'" />
  <battery-unknown v-else-if="valueName == 'battery_unknown'" />
  <bluetooth v-else-if="valueName == 'bluetooth'" />
  <bluetooth-connected v-else-if="valueName == 'bluetooth_connected'" />
  <bluetooth-disabled v-else-if="valueName == 'bluetooth_disabled'" />
  <bluetooth-searching v-else-if="valueName == 'bluetooth_searching'" />
  <brightness-auto v-else-if="valueName == 'brightness_auto'" />
  <brightness-high v-else-if="valueName == 'brightness_high'" />
  <brightness-low v-else-if="valueName == 'brightness_low'" />
  <brightness-medium v-else-if="valueName == 'brightness_medium'" />
  <data-usage v-else-if="valueName == 'data_usage'" />
  <developer-mode v-else-if="valueName == 'developer_mode'" />
  <devices v-else-if="valueName == 'devices'" />
  <dvr v-else-if="valueName == 'dvr'" />
  <gps-fixed v-else-if="valueName == 'gps_fixed'" />
  <gps-not-fixed v-else-if="valueName == 'gps_not_fixed'" />
  <gps-off v-else-if="valueName == 'gps_off'" />
  <graphic-eq v-else-if="valueName == 'graphic_eq'" />
  <location-disabled v-else-if="valueName == 'location_disabled'" />
  <location-searching v-else-if="valueName == 'location_searching'" />
  <mobile-friendly v-else-if="valueName == 'mobile_friendly'" />
  <mobile-off v-else-if="valueName == 'mobile_off'" />
  <nfc v-else-if="valueName == 'nfc'" />
  <screen-lock-landscape v-else-if="valueName == 'screen_lock_landscape'" />
  <screen-lock-portrait v-else-if="valueName == 'screen_lock_portrait'" />
  <screen-lock-rotation v-else-if="valueName == 'screen_lock_rotation'" />
  <screen-rotation v-else-if="valueName == 'screen_rotation'" />
  <sd-storage v-else-if="valueName == 'sd_storage'" />
  <settings-system-daydream
    v-else-if="valueName == 'settings_system_daydream'"
  />
  <signal-cellular-4-bar v-else-if="valueName == 'signal_cellular_4_bar'" />
  <signal-cellular-alt v-else-if="valueName == 'signal_cellular_alt'" />
  <signal-cellular-connected-no-internet-4-bar
    v-else-if="valueName == 'signal_cellular_connected_no_internet_4_bar'"
  />
  <signal-cellular-no-sim v-else-if="valueName == 'signal_cellular_no_sim'" />
  <signal-cellular-null v-else-if="valueName == 'signal_cellular_null'" />
  <signal-cellular-off v-else-if="valueName == 'signal_cellular_off'" />
  <signal-wifi-4-bar v-else-if="valueName == 'signal_wifi_4_bar'" />
  <signal-wifi-4-bar-lock v-else-if="valueName == 'signal_wifi_4_bar_lock'" />
  <signal-wifi-off v-else-if="valueName == 'signal_wifi_off'" />
  <storage v-else-if="valueName == 'storage'" />
  <thermostat v-else-if="valueName == 'thermostat'" />
  <usb v-else-if="valueName == 'usb'" />
  <wallpaper v-else-if="valueName == 'wallpaper'" />
  <widgets v-else-if="valueName == 'widgets'" />
  <wifi-lock v-else-if="valueName == 'wifi_lock'" />
  <wifi-tethering v-else-if="valueName == 'wifi_tethering'" />
</template>

<script>
import AccessAlarm from "@/components/Icons/Device/AccessAlarm";
import AccessAlarms from "@/components/Icons/Device/AccessAlarms";
import AccessTime from "@/components/Icons/Device/AccessTime";
import AdUnits from "@/components/Icons/Device/AdUnits";
import AddAlarm from "@/components/Icons/Device/AddAlarm";
import AddToHomeScreen from "@/components/Icons/Device/AddToHomeScreen";
import AirplanemodeActive from "@/components/Icons/Device/AirplanemodeActive";
import AirplanemodeInactive from "@/components/Icons/Device/AirplanemodeInactive";
import BatteryAlert from "@/components/Icons/Device/BatteryAlert";
import BatteryChargingFull from "@/components/Icons/Device/BatteryChargingFull";
import BatteryFull from "@/components/Icons/Device/BatteryFull";
import BatteryStd from "@/components/Icons/Device/BatteryStd";
import BatteryUnknown from "@/components/Icons/Device/BatteryUnknown";
import Bluetooth from "@/components/Icons/Device/Bluetooth";
import BluetoothConnected from "@/components/Icons/Device/BluetoothConnected";
import BluetoothDisabled from "@/components/Icons/Device/BluetoothDisabled";
import BluetoothSearching from "@/components/Icons/Device/BluetoothSearching";
import BrightnessAuto from "@/components/Icons/Device/BrightnessAuto";
import BrightnessHigh from "@/components/Icons/Device/BrightnessHigh";
import BrightnessLow from "@/components/Icons/Device/BrightnessLow";
import BrightnessMedium from "@/components/Icons/Device/BrightnessMedium";
import DataUsage from "@/components/Icons/Device/DataUsage";
import DeveloperMode from "@/components/Icons/Device/DeveloperMode";
import Devices from "@/components/Icons/Device/Devices";
import Dvr from "@/components/Icons/Device/Dvr";
import GpsFixed from "@/components/Icons/Device/GpsFixed";
import GpsNotFixed from "@/components/Icons/Device/GpsNotFixed";
import GpsOff from "@/components/Icons/Device/GpsOff";
import GraphicEq from "@/components/Icons/Device/GraphicEq";
import LocationDisabled from "@/components/Icons/Device/LocationDisabled";
import LocationSearching from "@/components/Icons/Device/LocationSearching";
import MobileFriendly from "@/components/Icons/Device/MobileFriendly";
import MobileOff from "@/components/Icons/Device/MobileOff";
import Nfc from "@/components/Icons/Device/Nfc";
import ScreenLockLandscape from "@/components/Icons/Device/ScreenLockLandscape";
import ScreenLockPortrait from "@/components/Icons/Device/ScreenLockPortrait";
import ScreenLockRotation from "@/components/Icons/Device/ScreenLockRotation";
import ScreenRotation from "@/components/Icons/Device/ScreenRotation";
import SdStorage from "@/components/Icons/Device/SdStorage";
import SettingsSystemDaydream from "@/components/Icons/Device/SettingsSystemDaydream";
import SignalCellular4Bar from "@/components/Icons/Device/SignalCellular4Bar";
import SignalCellularAlt from "@/components/Icons/Device/SignalCellularAlt";
import SignalCellularConnectedNoInternet4Bar from "@/components/Icons/Device/SignalCellularConnectedNoInternet4Bar";
import SignalCellularNoSim from "@/components/Icons/Device/SignalCellularNoSim";
import SignalCellularNull from "@/components/Icons/Device/SignalCellularNull";
import SignalCellularOff from "@/components/Icons/Device/SignalCellularOff";
import SignalWifi4Bar from "@/components/Icons/Device/SignalWifi4Bar";
import SignalWifi4BarLock from "@/components/Icons/Device/SignalWifi4BarLock";
import SignalWifiOff from "@/components/Icons/Device/SignalWifiOff";
import Storage from "@/components/Icons/Device/Storage";
import Thermostat from "@/components/Icons/Device/Thermostat";
import Usb from "@/components/Icons/Device/Usb";
import Wallpaper from "@/components/Icons/Device/Wallpaper";
import Widgets from "@/components/Icons/Device/Widgets";
import WifiLock from "@/components/Icons/Device/WifiLock";
import WifiTethering from "@/components/Icons/Device/WifiTethering";

export default {
  components: {
    AccessAlarm,
    AccessAlarms,
    AccessTime,
    AdUnits,
    AddAlarm,
    AddToHomeScreen,
    AirplanemodeActive,
    AirplanemodeInactive,
    BatteryAlert,
    BatteryChargingFull,
    BatteryFull,
    BatteryStd,
    BatteryUnknown,
    Bluetooth,
    BluetoothConnected,
    BluetoothDisabled,
    BluetoothSearching,
    BrightnessAuto,
    BrightnessHigh,
    BrightnessLow,
    BrightnessMedium,
    DataUsage,
    DeveloperMode,
    Devices,
    Dvr,
    GpsFixed,
    GpsNotFixed,
    GpsOff,
    GraphicEq,
    LocationDisabled,
    LocationSearching,
    MobileFriendly,
    MobileOff,
    Nfc,
    ScreenLockLandscape,
    ScreenLockPortrait,
    ScreenLockRotation,
    ScreenRotation,
    SdStorage,
    SettingsSystemDaydream,
    SignalCellular4Bar,
    SignalCellularAlt,
    SignalCellularConnectedNoInternet4Bar,
    SignalCellularNoSim,
    SignalCellularNull,
    SignalCellularOff,
    SignalWifi4Bar,
    SignalWifi4BarLock,
    SignalWifiOff,
    Storage,
    Thermostat,
    Usb,
    Wallpaper,
    Widgets,
    WifiLock,
    WifiTethering,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
